var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 469.333 469.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M298.667,63.998h-143.2L70.272,2.036c-3.232-2.357-7.531-2.688-11.115-0.875c-3.573,1.824-5.824,5.493-5.824,9.504v53.333 H32c-17.643,0-32,14.357-32,32V259.55c0,16.747,13.152,28.448,32,28.448h266.667c18.848,0,32-11.701,32-28.448V95.998 C330.667,78.356,316.309,63.998,298.667,63.998z M309.333,259.55c0,5.877-5.803,7.115-10.667,7.115H32 c-4.864,0-10.667-1.237-10.667-7.115V95.998c0-5.877,4.789-10.667,10.667-10.667h32c5.888,0,10.667-4.779,10.667-10.667V31.614 l71.061,51.68c1.813,1.323,4.021,2.037,6.272,2.037h146.667c5.888,0,10.667,4.789,10.667,10.667V259.55z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 58.667,
    cy: 175.998,
    r: 16
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 175.998,
    r: 16
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 165.333,
    cy: 175.998,
    r: 16
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 218.667,
    cy: 175.998,
    r: 16
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 175.998,
    r: 16
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.333,181.332h-74.667c-5.899,0-10.667,4.779-10.667,10.667s4.768,10.667,10.667,10.667h74.667 c4.864,0,10.667,1.237,10.667,7.115v163.552c0,5.877-4.779,10.667-10.667,10.667h-32c-5.899,0-10.667,4.779-10.667,10.667v43.051 l-71.061-51.68c-1.824-1.323-4.021-2.037-6.272-2.037H170.667c-5.877,0-10.667-4.789-10.667-10.667v-53.333 c0-5.888-4.779-10.667-10.667-10.667s-10.667,4.779-10.667,10.667v53.333c0,17.643,14.357,32,32,32h143.2l85.195,61.963 c1.856,1.355,4.064,2.037,6.272,2.037c1.653,0,3.307-0.384,4.843-1.163c3.573-1.824,5.824-5.493,5.824-9.504v-53.333h21.333 c17.643,0,32-14.357,32-32V209.78C469.333,193.033,456.181,181.332,437.333,181.332z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 378.667,
    cy: 325.332,
    r: 16
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 304,
    cy: 325.332,
    r: 16
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 229.333,
    cy: 325.332,
    r: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.9ff468eaa1515dfdf128597bc4bee636.svg";
export { ForwardRef as ReactComponent };